export default __webpack_public_path__ + "static/media/2004.c6542841.png";